import { call, put, takeLatest } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import * as actions from "@/store/slices/smartCooler.slice";
import * as api from "@/services/smartCooler";

const getErrorMessage = (error: any): string =>
    error?.response?.data?.message || error?.message || "An unexpected error occurred";

function* handleFetchCoolerList(
    action: ReturnType<typeof actions.fetchCoolerList>
): SagaIterator {
    try {
        const response = yield call(api.fetchCoolerList, action.payload);
        if (response?.data?.success || response?.status === 200) {
            yield put(actions.fetchCoolerListSuccess(response.data));
        } else {
            yield put(actions.fetchCoolerListFailure(response?.data?.message || "Failed to fetch coolers"));
        }
    } catch (error: any) {
        yield put(actions.fetchCoolerListFailure(getErrorMessage(error)));
    }
}

function* handleTriggerCoolerAction(
    action: ReturnType<typeof actions.triggerCoolerAction>
): SagaIterator {
    try {
        const response = yield call(api.triggerCoolerAction, action.payload);
        if (response?.data?.success || response?.status === 200 || response?.status === 201) {
            yield put(actions.triggerCoolerActionSuccess({
                message: response?.data?.message ?? null,
                data: response?.data?.data ?? null,
            }));
        } else {
            yield put(actions.triggerCoolerActionFailure(response?.data?.message || "Action failed"));
        }
    } catch (error: any) {
        yield put(actions.triggerCoolerActionFailure(getErrorMessage(error)));
    }
}

function* smartCoolerSaga(): SagaIterator {
    yield takeLatest(actions.fetchCoolerList.type, handleFetchCoolerList);
    yield takeLatest(actions.triggerCoolerAction.type, handleTriggerCoolerAction);
}

export default smartCoolerSaga;
